import { CurrentAdminFragment } from 'graphql/bindings/AdminBindings'
import LogRocket from 'logrocket'

import EnvVars from 'util/EnvVars'

export default {
  track(eventName: string | number, obj?: any, delay?: number, functionName = 'track') {
    if (window.analytics) {
      window.analytics[functionName](eventName, obj)
    } else {
      setTimeout(this.track.bind(this, eventName, obj, (delay || 100) * 2, functionName), delay)
    }
  },
  page(pathname: string | number, obj?: any) {
    this.track(pathname, obj, undefined, 'page')
  },
  identify(currentAdmin: CurrentAdminFragment) {
    const tags = {
      id: currentAdmin.id,
      email: currentAdmin.email,
      first_name: currentAdmin.first_name || '',
      last_name: currentAdmin.last_name || '',
    }
    this.track(currentAdmin.id, tags, undefined, 'identify')
    if (EnvVars.ENVIRONMENT === 'production') {
      LogRocket.identify(currentAdmin.id + '', tags)
    }
  },
  injectLogRocket() {
    if (EnvVars.ENVIRONMENT === 'production') {
      var logRocketToken = 'equidate/market-console-prod'
      LogRocket.init(logRocketToken)
    }
  },
}
